var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"width":"100%","z-index":"1","border-radius":"20px!important"},attrs:{"flat":""}},[_c('GmapMap',{ref:"googleMap",staticStyle:{"width":"100%"},style:(`height: 180px`),attrs:{"center":_vm.userPosition,"zoom":_vm.zoom,"map-type-id":"roadmap","options":{
          clickableIcons: false,
           zoomControl: false,
           mapTypeControl: false,
           scaleControl: false,
           streetViewControl: false,
           rotateControl: false,
           fullscreenControl: false,
           disableDefaultUi: true,
           gestureHandling: 'none',
           draggable: false,
           scrollwheel: false,
           isFractionalZoomEnabled: false,
           keyboardShortcuts: false,
           styles: _vm.mapStyle
       }},scopedSlots:_vm._u([(_vm.isMapInitialized == true)?{key:"visible",fn:function(){return [_c('GmapMarker',{attrs:{"icon":_vm.userMarker,"position":_vm.userPosition,"clickable":false,"draggable":false}})]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }